
import { Component } from 'vue-property-decorator';
import AppIndexViewBase from './app-index-view-appmenu-base.vue';
import { menuJumpTo } from "@/utils/menu-path/menu-path";
import { Http } from '@/utils';
@Component({
    components: {

    }
})
export default class AppIndexView extends AppIndexViewBase {

    public menuJumpTo(path: any, item: any) {
        menuJumpTo(path, item, this)
        Http.getInstance().post('/runtimeapi/menuLog//save?menuName='+item.label).then((res:any) => {
            // menuJumpTo(path, item, this)
        });

    }
}
